/* =============================================================
   FG — Limite per gioco (massimo N pezzi dello stesso titolo)

   Guardia nel carrello. Fa DUE cose e nient'altro:
     1. se una riga del carrello supera il massimo, la riporta al massimo
     2. sulla scheda di un gioco limitato, tappa il selettore quantita'

   REGOLA DI PRUDENZA: questo codice puo' solo ABBASSARE una quantita', e
   solo su prodotti che ha confermato essere nella collezione limitata. Non
   aggiunge, non toglie righe, non tocca nient'altro nel carrello. La sera
   prima di una tornata di offerte, un errore che alza le quantita' o svuota
   il carrello costa vendite vere: qui non e' proprio possibile.
   ============================================================= */
(function () {
  'use strict';

  var CFG = window.FG_LIMITE;
  if (!CFG || !CFG.attivo || !CFG.collezione) return;

  var MAX = parseInt(CFG.max, 10) || 3;
  var CHIAVE = 'fg_limite_' + CFG.collezione;

  /* L'elenco dei giochi limitati viene dalla collezione stessa: cosi' segue
     il tag senza che nessuno debba aggiornare una lista a mano. Tenuto in
     sessione perche' entro una visita non cambia, e sono 250 prodotti. */
  function elenco() {
    try {
      var cache = sessionStorage.getItem(CHIAVE);
      if (cache) return Promise.resolve(new Set(JSON.parse(cache)));
    } catch (e) { /* sessione non disponibile: si scarica e basta */ }

    return fetch('/collections/' + CFG.collezione + '/products.json?limit=250', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var handles = (d.products || []).map(function (p) { return p.handle; });
        /* Un elenco VUOTO non si mette in cache. Oggi la collezione e'
           ancora vuota: chi visita adesso si terrebbe il vuoto per tutta la
           sessione, e quando i giochi vengono taggati fra dieci minuti il
           limite non varrebbe per lui. */
        if (handles.length) {
          try { sessionStorage.setItem(CHIAVE, JSON.stringify(handles)); } catch (e) {}
        }
        return new Set(handles);
      })
      .catch(function () { return new Set(); });
  }

  /* ---------- 1. La guardia nel carrello ---------- */

  var occupato = false;

  function avviso(titoli) {
    var vecchio = document.querySelector('[data-fg-limite-avviso]');
    if (vecchio) vecchio.remove();

    var p = document.createElement('div');
    p.setAttribute('data-fg-limite-avviso', '');
    p.setAttribute('role', 'status');
    p.textContent = titoli.length === 1
      ? 'Di ' + titoli[0] + ' puoi prenderne al massimo ' + MAX + '. Ho sistemato il carrello.'
      : 'Di questi giochi puoi prenderne al massimo ' + MAX + ' a testa. Ho sistemato il carrello.';
    p.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:20px;z-index:9999;' +
      'max-width:min(520px,calc(100vw - 24px));padding:14px 18px;border-radius:12px;' +
      'background:#18181B;color:#fff;font:600 14px/1.4 Inter,sans-serif;text-align:center;' +
      'box-shadow:0 8px 28px rgba(0,0,0,.3)';
    document.body.appendChild(p);
    setTimeout(function () { p.remove(); }, 7000);
  }

  function controlla(limitati) {
    if (occupato || !limitati.size) return;
    occupato = true;

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var oltre = (cart.items || []).filter(function (i) {
          return limitati.has(i.handle) && i.quantity > MAX;
        });
        if (!oltre.length) return null;

        /* Una riga per volta e in sequenza: /cart/change.js rinumera le
           righe a ogni chiamata, e mandarne due insieme significa che la
           seconda lavora su un carrello che non esiste piu'. */
        var catena = Promise.resolve();
        oltre.forEach(function (i) {
          catena = catena.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: i.key, quantity: MAX })
            });
          });
        });

        return catena.then(function () {
          avviso(oltre.map(function (i) { return i.product_title; }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        });
      })
      .catch(function () { /* offline: il carrello resta com'e' */ })
      .then(function () { occupato = false; });
  }

  /* ---------- 2. Il tappo sulla scheda ---------- */

  /* Applicato una volta sola non teneva: il tema rigenera il modulo
     d'acquisto dopo il caricamento (cambio variante, sezioni ricaricate) e
     si riporta via l'attributo. Verificato dal vivo: max restava vuoto.
     Quindi si guarda chi entra nel DOM, invece di sperare nel momento
     giusto. Osservatore con freno: al massimo un giro ogni 200ms. */
  function tappaOra() {
    document.querySelectorAll('.quantity__input, input[name="quantity"]').forEach(function (inp) {
      var attuale = parseInt(inp.getAttribute('max'), 10);
      if (!attuale || attuale > MAX) {
        inp.setAttribute('max', MAX);
        inp.setAttribute('data-max', MAX);
      }
      if ((parseInt(inp.value, 10) || 1) > MAX) inp.value = String(MAX);
    });
  }

  /* La regola va DETTA PRIMA che morda. Un «+» che non fa niente, senza una
     parola, e' la frizione peggiore che ci sia: il cliente non capisce se e'
     rotto il sito o se ha sbagliato lui. Scritta prima, la stessa regola
     cambia di segno — non e' un ostacolo, e' il negozio che dice che queste
     offerte le protegge da chi fa incetta. */
  function nota() {
    if (document.querySelector('[data-fg-limite-nota]')) return;

    var inp = document.querySelector('.quantity__input');
    if (!inp) return;
    var box = inp.closest('quantity-input') || inp.parentElement;
    if (!box || !box.parentElement) return;

    var stile = document.createElement('style');
    stile.textContent =
      /* riga intera: il contenitore e' flex-wrap, e senza questo un domani
         la nota potrebbe stringersi accanto al bottone */
      '[data-fg-limite-nota]{flex:1 0 100%;margin:8px 0 0;font:600 13px/1.3 Inter,sans-serif;color:#6B7280;' +
      'display:flex;align-items:center;gap:6px;transition:color .2s ease}' +
      '[data-fg-limite-nota].is-hit{color:#B45309}';

    var p = document.createElement('p');
    p.setAttribute('data-fg-limite-nota', '');
    p.textContent = 'Massimo ' + MAX + ' pezzi per ordine, così tocca a tutti.';

    box.parentElement.insertBefore(stile, box.nextSibling);
    box.parentElement.insertBefore(p, stile.nextSibling);

    /* Quando il cliente prova ad andare oltre, la riga si accende invece di
       restare grigia: e' la risposta al «+» che sembrava rotto. */
    function segnala() {
      if ((parseInt(inp.value, 10) || 1) >= MAX) {
        p.classList.add('is-hit');
        clearTimeout(p._t);
        p._t = setTimeout(function () { p.classList.remove('is-hit'); }, 1400);
      }
    }
    box.addEventListener('click', segnala);
    inp.addEventListener('change', segnala);
  }

  function tappaSelettore(limitati) {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m || !limitati.has(m[1])) return;

    tappaOra();
    nota();

    var freno = null;
    new MutationObserver(function () {
      clearTimeout(freno);
      freno = setTimeout(function () { tappaOra(); nota(); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 3. La regola in testata allo Speciale ----------
     Dalla griglia si compra con l'aggiunta rapida SENZA passare dalla
     scheda: senza questa riga il limite tornerebbe a farsi vivo solo nel
     carrello, che e' il blocco muto che stiamo evitando.
     Una volta sola, in testata, fra gli altri fatti — non su ogni card:
     quaranta scatole che ripetono «massimo 3» leggono come diffidenza, e
     la stragrande maggioranza dei clienti ne prende uno.
     Il numero lo scrive questo file, che e' anche quello che lo applica.
     Ricopiarlo nella sezione avrebbe voluto dire due posti da tenere
     allineati a mano. */
  function regolaInTestata() {
    var sez = document.querySelector('[data-asm][data-asm-coll="' + CFG.collezione + '"]');
    if (!sez) return;

    var fatti = sez.querySelector('.asm-facts');
    if (!fatti || fatti.querySelector('[data-fg-limite-fatto]')) return;

    var t = document.createElement('div');
    t.className = 'asm-fact';
    t.setAttribute('data-fg-limite-fatto', '');
    t.innerHTML = '<dt></dt><dd></dd>';
    t.querySelector('dt').textContent = 'Massimo per gioco';
    t.querySelector('dd').textContent = MAX + ' pezzi';
    fatti.appendChild(t);
  }

  /* ---------- Avvio ---------- */

  elenco().then(function (limitati) {
    if (!limitati.size) return;

    tappaSelettore(limitati);
    regolaInTestata();
    controlla(limitati);

    var attesa = null;
    function programma() {
      clearTimeout(attesa);
      attesa = setTimeout(function () { controlla(limitati); }, 400);
    }
    document.addEventListener('cart:updated', programma);
    document.addEventListener('cart:refresh', programma);
  });
})();
